import React, { FC, FocusEventHandler, KeyboardEventHandler } from 'react';
import Select, {
  ActionMeta,
  GroupBase,
  InputActionMeta,
  MultiValue,
  OptionsOrGroups,
  StylesConfig,
} from 'react-select';
import { SelectComponents } from 'react-select/dist/declarations/src/components';
import classNames from 'classnames';
import { Option } from '../interfaces/option.interface';
import './styles.scss';

interface MultiSelectDropdownInputBaseProps {
  className?: string;
  components?: Partial<SelectComponents<Option, true, GroupBase<Option>>>;
  inputValue?: string;
  isClearable?: boolean;
  isMenuOpen?: boolean;
  onChange?: (newValue: MultiValue<Option>, actionMeta: ActionMeta<Option>) => void;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onInputChange?: (newValue: string, actionMeta: InputActionMeta) => void;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
  options?: OptionsOrGroups<Option, GroupBase<Option>>;
  placeholder?: string;
  styles?: StylesConfig<Option, true, GroupBase<Option>>;
  value?: MultiValue<Option>;
  wrapperClassName?: string;
}

export const MultiSelectDropdownInputBase: FC<MultiSelectDropdownInputBaseProps> = ({
  className,
  inputValue,
  onChange,
  onInputChange,
  onFocus,
  onKeyDown,
  options,
  placeholder,
  wrapperClassName,
  isMenuOpen,
  value,
  styles,
  components,
  isClearable,
}) => {
  return (
    <div className={classNames('dropdown-input-multi-select', wrapperClassName)}>
      <Select
        styles={styles}
        className={classNames(className)}
        onFocus={onFocus}
        menuIsOpen={isMenuOpen}
        onChange={onChange}
        onInputChange={onInputChange}
        onKeyDown={onKeyDown}
        options={options}
        value={value}
        isMulti
        isClearable={isClearable}
        placeholder={placeholder}
        inputValue={inputValue}
        components={{
          IndicatorSeparator: () => null,
          ...components,
        }}
      />
    </div>
  );
};
